import { PublicClientApplication } from '@azure/msal-browser';

export const azureFetchToken = async (msalInstance: PublicClientApplication) => {
  await msalInstance.handleRedirectPromise();
  const account = msalInstance.getActiveAccount() ?? undefined;
  let token = undefined;
  try {
    token = await msalInstance.acquireTokenSilent({
      account,
      scopes: [import.meta.env.VITE_API_SCOPES],
    });
  } catch {
    token = await msalInstance.acquireTokenRedirect({
      scopes: [import.meta.env.VITE_API_SCOPES],
    });
  }

  if (token) {
    return `Bearer ${token.accessToken}`;
  }
};
